import { Component, OnInit } from '@angular/core';

import { DragulaService } from 'ng2-dragula/ng2-dragula';

import { ProjectsService } from '../../../work/services/projects.service';

import { ProjectModel } from '../../../../modules/models';

import { DashboardConstants } from '../../dashboard.const';

@Component({
  selector: 'app-main-board',
  templateUrl: './main-board.component.html'
})
export class MainBoardComponent implements OnInit {

  sprintBoard: any=[] ;
  formData: any = {};
  projectList: Array<ProjectModel> = [];
  sprints: Array<any> = [];
  project: any;
  sprint: any;
  taskId: any
  sprintObj: any = {};
  projectObj: any = {};
  pageId:number = 0;

  dashboardConstants: any = DashboardConstants;

  constructor(
    private projectsService : ProjectsService,
    private dragulaService: DragulaService
  ) {
    dragulaService.drop.subscribe((value) => {
      this.onDrop(value.slice(1));
    });
  }

  ngOnInit() {
    this.loadProjects();
  }

  onDrop(args) {
    let [e, target, source] = args;
    let item = {
      id: e.dataset.itemid,
      ver_id: e.dataset.itemversion
    }
    this.updateTask(item, target.id);
  }

  onChangeProject(event){
    this.getSprints(this.project,this.pageId);
    this.getProjectById();
  }

  onChangeSprint(){
    this.getFormdata(this.sprint, this.project);
    this.getSprintBoard(this.sprint);
    this.getSprint();
  }

  updateTask(item, status){
    this.projectsService.updateSprintBoard(this.sprint, item, status).subscribe(
      sprintBoard => {
        this.getSprintBoard(this.sprint);
      },error =>{
        this.getSprintBoard(this.sprint);
      }
    );
  }

  loadProjects() {
    this.projectsService.loadAllProjects().subscribe(
      result => {
        this.projectList = result.projects;
        if(this.projectList && this.projectList.length > 0){
          this.project = this.projectList[0].project_id;
          this.getSprints(this.projectList[0].project_id,this.pageId);
          this.getProjectById();
        }else{
          this.project = "";
        }
      }
    );
  }

  /**
   * get all sprint in project
   */
  getSprints(projectId,pageId) {
    this.projectsService.getSprints(projectId,pageId).subscribe(
      sprints => {
        this.sprints = sprints.data;
        if(this.sprints && this.sprints.length > 0){
          this.sprint = this.getCurrentSprint() ? this.getCurrentSprint().id : this.sprints[0].id;
          this.getFormdata(this.sprint, this.project);
          this.getSprintBoard(this.sprint);
          this.getSprint();
        }else{
          this.sprint = '';
          this.sprintBoard = [];
          this.sprintObj = {};
        }
      }
    );
  }

  getCurrentSprint(){
    let currentDate = new Date().getTime();
    let currentSprint = this.sprints.filter(sprint => {
        let startDate = new Date(sprint.start_date).getTime();
        let endDate = new Date(sprint.end_date).getTime();
        return startDate <= currentDate && endDate >= currentDate;
    });
    return currentSprint[0];
  }

  getSprintBoard(sprintId){
    this.projectsService.getSprintBoard(sprintId).subscribe(
      sprintBoard => {
        this.sprintBoard = sprintBoard.data;
      },error => {

      }
    );
  }

  /**
   * get all form data
   */
  getFormdata(sprintId, projectId) {
    this.projectsService.getSprintFormData(sprintId, projectId).subscribe(
      formData => {
        this.formData = formData.data;
      }
    );
  }

  /**
   * get project details by project Id
   */
  getProjectById() {
    this.projectsService.getProjectById(this.project).subscribe(
      project => {
        this.projectObj = project.project;
      }
    );
  }

  getSprint() {
    this.projectsService.getSprint(this.project, this.sprint).subscribe(
      sprint => {
        this.sprintObj = sprint.data;
      }
    );
  }

  openTimesheet(taskId) {
    this.taskId = taskId;
  }

  

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/main-board/main-board.component.ts